import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Estado vazio ou de erro exibido no lugar do conteúdo esperado. */
export function Estado({ titulo, texto, variante = 'vazio', children }) {
    return (_jsxs("div", { className: variante === 'erro' ? 'estado estado--erro' : 'estado', role: variante === 'erro' ? 'alert' : undefined, children: [_jsx("p", { className: "estado__titulo", children: titulo }), _jsx("p", { className: "estado__texto", children: texto }), children] }));
}
/** Indicador de operação em andamento. */
export function Carregando({ texto }) {
    return (_jsxs("span", { className: "carregando", role: "status", children: [_jsx("span", { className: "girando", "aria-hidden": "true" }), texto] }));
}
